module.exports = __webpack_public_path__ + "8856f2847ea0c6fa4a076ef65bdedf39.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-princess-6.png
// module id = 500
// module chunks = 0